import React from "react";
import styled from "styled-components";

const IconWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  padding: 6px;
  cursor: pointer;
  transition: transform 0.2s ease;
  z-index: 2;

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

interface FavoriteIconProps {
  isFavorite: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const FavoriteIcon: React.FC<FavoriteIconProps> = ({ isFavorite, onClick }) => (
  <IconWrapper onClick={onClick}>
    <img
      src={isFavorite ? "/common/recommendation_activate.svg" : "/common/recommendation.svg"}
      alt={isFavorite ? "Favorite Active" : "Favorite"}
    />
  </IconWrapper>
);

export default FavoriteIcon;
